export class SetProperties {
  constructor() {
  }
  setProperties(obj) {
    if (obj) {
      for (const prop in this) {
        if (obj.hasOwnProperty(prop)) this[prop] = obj[prop]
      }
    }
  }
}
